// extracted by mini-css-extract-plugin
export default {"settings":"y3Vkg","section":"yuwmo","sectionImage":"oTt_B","sectionTitle":"uLPb5","image":"ebtn2"};